<template>
    <div class="def-like" @click="handlerChangeData()">
        <svg v-if="!checkFavorite(id)">
            <use xlink:href="#svg-heart-stroke"></use>
        </svg>
        <svg v-else>
            <use xlink:href="#svg-heart-fill"></use>
        </svg>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'def-like',
        selector: '.def-like',
        props: ['result'],
        computed: {
            ...mapGetters({
                checkFavorite: 'favourite/checkElementInFavorite',
            }),
            ...mapState({
                groups: ({favourite}) => favourite?.data?.group,
            }),
            // checkFavorite() {
            //     try {
            //         this.$store.dispatch('favourite/checkElementInFavorite', this.id);
            //         // return window.favourite.checkElementInFavorite(this.id);
            //     } catch (err) {
            //         console.warn('problems with connection to component vue favourite is', window.favourite);
            //         console.error(err);
            //         return false;
            //     }
            // },
            id() {
                try {
                    return this.result?.offer?.id || this.result?.id;
                } catch (err) {
                    console.error(err);
                }
            },
            searchMainGroup() {
               return this.groups.find( el => el.base === 'Y');
            }
        },
        methods: {
            handlerChangeData() {
                try{
                    const data = {id: this.id, groupId: this.searchMainGroup.id}
                    if (this.checkFavorite(this.id)) {
                        this.$store.dispatch('favourite/deleteFromFavorite', data);
                    } else {
                        this.$store.dispatch('favourite/addToFavorite', this.id);
                    }
                } catch (err) {
                    console.warn('problems with connection to component vue favourite is', window.favourite);
                    console.error(err);
                }
            },
        },
        mounted() {
        }

    }
</script>

<style lang="scss">
    .def-like {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;

        svg {
            width: 16px;
            height: 16px;
        }

        &:hover {
            cursor: pointer;
        }
    }
</style>